module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6Bwsr"))).then(() => parcelRequire('9Lwss'));